module.exports = __webpack_public_path__ + "img/smile-bird.81cdbba.png?v=1745915539466";